import type { StatCardProps } from "@/components/molecules/StatCard";
import { Calendar2 } from "iconsax-react";


export interface Event {
    id: string;
    eventID: string;
    title: string;
    type: string;
    host: string;
    participants: number;
    date: string;
    location: string;
    status: "Upcoming" | "Cancelled" | "Completed";
}

export const EVENTS_STATS: StatCardProps[] = [
    {
        title: "Total Upcoming Events",
        value: "200",
        icon: <Calendar2 variant="Bold" color="#484848" className="w-6 h-6" />,
    },
    {
        title: "Scheduled User Dates",
        value: "20",
        icon: <Calendar2 variant="Bold" color="#484848" className="w-6 h-6" />,
    },
    {
        title: "Group Meetups",
        value: "50",
        icon: <Calendar2 variant="Bold" color="#484848" className="w-6 h-6" />,
    },
    {
        title: "Cancelled This Week",
        value: "20",
        icon: <Calendar2 variant="Bold" color="#484848" className="w-6 h-6" />,
    },
]

export const MOCK_EVENTS: Event[] = [
    {
        id: "1",
        eventID: "EVT-0892",
        title: "Coffee Social",
        type: "Group Meetup",
        host: "Café Roma",
        participants: 25,
        date: "18 Sep 2025, 4:00 PM",
        location: "NY",
        status: "Upcoming",
    },
    {
        id: "2",
        eventID: "EVT-0893",
        title: "Movie Night",
        type: "User Date",
        host: "John + Sarah",
        participants: 15,
        date: "18 Sep 2025, 7:00 PM",
        location: "PA",
        status: "Completed",
    },
    
]

export const EVENT_TABLE_HEADERS = [
    "Event ID",
    "Title",
    "Type",
    "Host",
    "Participants",
    "Date & Time",
    "Location",
    "Status",
]